import { GroupInterface } from "@swivl-mono/types";
import { SelectItem } from "@swivl-mono/ui";

interface LocationAddressLike {
  city?: string;
  state?: string;
}

/** "Austin, TX" · "Austin" · "TX" · undefined — never a bare comma. */
export function locationSublabel(location: LocationAddressLike): string | undefined {
  const parts = [location.city, location.state].filter((part): part is string => !!part);
  return parts.length > 0 ? parts.join(", ") : undefined;
}

/**
 * Group-headered picker options with address sublines, for the reassign SearchSelect — the same
 * `locationOptions` shape BulkImportPage already builds, enriched with each location's city/state
 * (from a separate DocumentIngest-scoped lookup; the shared LocationInterface carries no address).
 */
export function buildLocationPickerOptions(groups: GroupInterface[], addressById: Map<number, LocationAddressLike>): SelectItem[] {
  return groups.map((group) => ({
    type: "group",
    label: group.name,
    options: group.locations.map((location) => ({
      label: location.name,
      sublabel: locationSublabel(addressById.get(location.id) ?? {}),
      value: `loc:${location.id}`
    }))
  }));
}

/**
 * Same grouped/sublabeled shape as `buildLocationPickerOptions`, but with bare location-id-string
 * values (no `loc:` prefix) — for a multi-select ChipSelect whose `selectedValues` are diffed
 * directly against numeric location ids (AffectedLocationsField), not parsed like the reassign
 * picker's prefixed values.
 */
export function buildLocationCheckboxOptions(groups: GroupInterface[], addressById: Map<number, LocationAddressLike>): SelectItem[] {
  return groups.map((group) => ({
    type: "group",
    label: group.name,
    options: group.locations.map((location) => ({
      label: location.name,
      sublabel: locationSublabel(addressById.get(location.id) ?? {}),
      value: String(location.id)
    }))
  }));
}
